import "antd/es/layout/style";
import _Layout from "antd/es/layout";
export default _Layout;
//# sourceMappingURL=index.js.map